export default __webpack_public_path__ + "static/media/waves_about.dabf4c5a.png";